import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "icon"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "base-calculator-v2__branch-select slider-container"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "icon"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: "icon"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]

import BranchInterface from '@/interfaces/BranchInterface';
import { computed, PropType, ref } from 'vue';
import ResponsiveSize from '@/classes/ResponsiveSize';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBoltLightning, faFireFlameCurved } from '@fortawesome/pro-light-svg-icons';
import { faChevronsRight, faChevronsLeft } from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCalculatorV2BranchSelect',
  props: {
  modelValue: {
    type: Object as PropType<BranchInterface>,
    required: true,
  },
  branches: Object as PropType<Array<BranchInterface>>,
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

library.add(faBoltLightning);
library.add(faFireFlameCurved);
library.add(faChevronsRight);
library.add(faChevronsLeft);




const isMobile = ResponsiveSize.isMobileBreakpoint();

const isSingleBranch = computed(() => props.branches?.length === 1);

const branchType = ref('');

const value = computed<BranchInterface>({
  get: () => props.modelValue,
  set(val) {
    emit('update:modelValue', val);
  },
});

const clickCounts = ref<{ [key: string]: number }>({});

const onSelectBranch = (branch: BranchInterface): void => {
  if (branch.isUrl && branch.url && isMobile) {
    if (!clickCounts.value[branch.slug]) {
      clickCounts.value[branch.slug] = 1;

      return;
    } if (clickCounts.value[branch.slug] === 1) {
      window.location.href = branch.url;

      return;
    }
  } else if (branch.isUrl && branch.url && !isMobile) {
    window.location.href = branch.url;
  }

  const previouslySelectedBranch = document.querySelector('.branch.selected');
  if (previouslySelectedBranch) {
    previouslySelectedBranch.classList.remove('selected');
  }

  const clickedBranch = document.querySelector(`.${branch.slug}`);
  if (clickedBranch) {
    clickedBranch.classList.add('selected');
  }

  value.value = branch;
  branchType.value = branch.slug;
};

const currentSlide = ref(0);

const changeSlide = (direction: number): void => {
  const totalSlides = props.branches?.length;
  currentSlide.value += direction;

  if (currentSlide.value >= totalSlides) {
    currentSlide.value = 0;
  } else if (currentSlide.value < 0) {
    currentSlide.value = totalSlides - 1;
  }

  props?.branches.forEach((branch) => {
    clickCounts.value[branch.slug] = 0;
  });

  onSelectBranch(props?.branches[currentSlide.value]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["base-calculator-v2__branch-select", {
        single: isSingleBranch.value,
      }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.branches, (branch) => {
            return (_openBlock(), _createElementBlock("div", {
              key: branch.slug || branch.name,
              class: _normalizeClass(["branch", {
          selected: value.value.slug === branch.slug,
        }]),
              onClick: ($event: any) => (onSelectBranch(branch))
            }, [
              (branch.isUrl && branch.customIcon?.startsWith('fa'))
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: branch.customIcon
                    }, null, 8, ["icon"])
                  ]))
                : (branch.isUrl && branch.customIcon)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "icon-svg",
                      innerHTML: branch.customIcon
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true),
              (branch.icon)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_unref(FontAwesomeIcon), {
                      icon: branch.icon
                    }, null, 8, ["icon"])
                  ]))
                : (branch.svg)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: "icon-svg",
                      innerHTML: branch.svg
                    }, null, 8, _hoisted_5))
                  : (branch.image)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        class: "image",
                        style: _normalizeStyle({ backgroundImage: `url(${branch.image.url})` })
                      }, null, 4))
                    : _createCommentVNode("", true),
              _createElementVNode("span", {
                innerHTML: branch.name
              }, null, 8, _hoisted_6)
            ], 10, _hoisted_1))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "prev",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSlide(-1)))
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevrons-left" })
        ]))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "slider",
            style: _normalizeStyle({ transform: `translateX(calc(${-currentSlide.value * (100 / 3.5)}%))` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.branches, (branch) => {
              return (_openBlock(), _createElementBlock("div", {
                key: branch.slug || branch.name,
                class: _normalizeClass(["branch slide", {
            selected: value.value.slug === branch.slug,
            }]),
                onClick: ($event: any) => (onSelectBranch(branch))
              }, [
                (branch.isUrl && branch.customIcon?.startsWith('fa'))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: branch.customIcon
                      }, null, 8, ["icon"])
                    ]))
                  : (branch.isUrl && branch.customIcon)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "icon-svg",
                        innerHTML: branch.customIcon
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                (branch.icon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createVNode(_unref(FontAwesomeIcon), {
                        icon: branch.icon
                      }, null, 8, ["icon"])
                    ]))
                  : (branch.svg)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: "icon-svg",
                        innerHTML: branch.svg
                      }, null, 8, _hoisted_12))
                    : (branch.image)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 4,
                          class: "image",
                          style: _normalizeStyle({ backgroundImage: `url(${branch.image.url})` })
                        }, null, 4))
                      : _createCommentVNode("", true),
                _createElementVNode("span", {
                  innerHTML: branch.name
                }, null, 8, _hoisted_13)
              ], 10, _hoisted_8))
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "next",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSlide(1)))
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-chevrons-right" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})